module.exports = __webpack_public_path__ + "fonts/nunito-extrabold.6045ec0.woff2";